<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized">
  <page-load-header *ngIf="!initialized"></page-load-header>

  <div *ngIf="initialized" class="col-md-12 order-md-1 p-0">
    <form class="form" (ngSubmit)="onSave()" [formGroup]="formGroup" novalidate>
      <div class="sticky-top bg-light pt-2">
        <div class="row">
          <div class="col-sm-6 pull-left">
            <button class="btn btn-outline-dark" (click)="onCancel()" type="button">Cancel</button>
          </div>
          <div class="col-sm-6 text-right pull-right">
            <button class="btn btn-primary" [promiseBtn]="submitComplete" type="submit">Save</button>
          </div>
        </div>
        <hr class="mb-4" />
      </div>
      <h4 class="mb-3">Author Course</h4>
      <div class="card mb-5">
        <div class="card-header pb-0">
          <h5>Step 1. Choose Recording Method</h5>
        </div>

        <div class="card-body">
          <div class="row mb-3">
            <div class="col-md-12 col-lg-9 col-xl-8 col-xxl-6">
              <div class="row mx-gutters-2">
                <div class="col-6 col-md-4 mb-3 mb-md-0">
                  <div class="custom-control custom-radio custom-control-inline checkbox-outline text-center">
                    <input type="radio" id="typeOfListingRadio1" name="recordingMethod" formControlName="recordingMethod" [value]="RecordingMethod.Self" class="custom-control-input checkbox-outline__input" />
                    <label class="checkbox-outline__label rounded py-3 px-1 mb-0" for="typeOfListingRadio1">
                      <img class="js-svg-injector w-50 mb-3" src="../../assets/svg/icons/upload-video.svg" alt="SVG" data-parent="#uploadForm" />
                      <span class="d-block">I have/will provide my own recording</span>
                    </label>
                  </div>
                </div>
                <div class="col-6 col-md-4 mb-3 mb-md-0">
                  <div class="custom-control custom-radio custom-control-inline checkbox-outline text-center">
                    <input type="radio" id="typeOfListingRadio2" name="recordingMethod" formControlName="recordingMethod" [value]="RecordingMethod.Remote" class="custom-control-input checkbox-outline__input" checked />
                    <label class="checkbox-outline__label rounded py-3 px-1 mb-0" for="typeOfListingRadio2">
                      <img class="js-svg-injector w-50 mb-3" src="../../assets/svg/icons/monitor.svg" alt="SVG" data-parent="#uploadForm" />
                      <span class="d-block">Record remotely with our platform</span>
                    </label>
                  </div>
                </div>
                <div class="col-6 col-md-4">
                  <div class="custom-control custom-radio custom-control-inline checkbox-outline text-center">
                    <input type="radio" id="typeOfListingRadio3" name="recordingMethod" formControlName="recordingMethod" [value]="RecordingMethod.Studio" class="custom-control-input checkbox-outline__input" />

                    <label class="checkbox-outline__label rounded py-3 px-1 mb-0" for="typeOfListingRadio3">
                      <img class="js-svg-injector w-50 mb-3" src="../../assets/svg/icons/presentation-podium.svg" alt="SVG" data-parent="#uploadForm" />
                      <span class="d-block">Record in our Atlanta studio</span>
                    </label>
                  </div>
                </div>
                <div class="row" *ngIf="!formGroup.controls['recordingMethod'].valid && formGroup.controls['recordingMethod'].dirty">
                  <div class="col-md-12">
                    <div class="invalid-message-visible">
                      <div class="ml-2">Recording Method is Required</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End Radio Checkbox Group -->
            </div>
          </div>
        </div>
        <ng-container *ngIf="formGroup.controls['recordingMethod'].valid">
          <div class="card-header border-top pb-0">
            <h5>Step 2. Event title and details</h5>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-md-5 mb-3">
                <label for="firstName">Event Title</label>
                <i class="fa fa-asterisk"></i>
                <input type="text" class="form-control" formControlName="title" />
                <div class="invalid-message">
                  <div>Event Title is required</div>
                </div>
              </div>
              <div class="col-md-3 mb-3">
                <label for="country">Suggested Price</label>
                <i class="fa fa-asterisk"></i>
                <kendo-numerictextbox [format]="'c0'" [min]="0" class="form-control" formControlName="price"></kendo-numerictextbox>
                <div class="invalid-message">
                  <div>Price is required</div>
                </div>
              </div>
            </div>
          </div>

          <h5 class="card-header border-top">Continuing Education</h5>
          <div class="card-body">
            <div class="row no-gutters no-candidates" style="min-height: 200px" *ngIf="!certifications || certifications.length == 0">
              <div class="col-sm-12 my-auto">
                <h1><i class="fas fa-empty-set"></i></h1>
                <h4>No Certifications for this organization</h4>
                <p>This organization has not added any certifications yet. You will need to add certifications in order to offer CEs for this organization.</p>
              </div>
            </div>
            <ng-container formArrayName="ceus" *ngFor="let cert of certifications; let i = index">
              <div [formGroupName]="i" class="row mb-3">
                <div class="col-md-3">
                  <label for="country">{{ cert.certificationBody.shortName }} {{cert.certificationBody.baseTypeName}}  {{ cert.certificationBody.unitName }}</label>
                  <i class="fa fa-asterisk"></i>
                  <input type="hidden" formControlName="certificationBodyId" />
                  <select class="form-control" formControlName="ceuCount">
                    <option [value]="0">0</option>
                    <option [value]=".5">.5</option>
                    <option [value]="1">1</option>
                    <option [value]="1.5">1.5</option>
                    <option [value]="2">2</option>
                    <option [value]="2.5">2.5</option>
                    <option [value]="3">3</option>
                    <option [value]="3.5">3.5</option>
                    <option [value]="4">4</option>
                    <option [value]="4.5">4.5</option>
                    <option [value]="5">5</option>
                    <option [value]="5.5">5.5</option>
                    <option [value]="6">6</option>
                    <option [value]="6.5">6.5</option>
                  </select>
                  <div class="invalid-message">
                    <div>{{cert.certificationBody.baseTypeName}}  {{ cert.certificationBody.unitName }} are required</div>
                  </div>
                </div>
                <div *ngIf="cert.certificationBody.subType1Name" class="col-md-3">
                  <label for="country">{{ cert.certificationBody.shortName }} {{ cert.certificationBody.subType1Name }} {{ cert.certificationBody.unitName }}</label>
                  <i class="fa fa-asterisk"></i>
                  <select class="form-control" formControlName="subType1CeuCount">
                    <option [value]="0">0</option>
                    <option [value]=".5">.5</option>
                    <option [value]="1">1</option>
                    <option [value]="1.5">1.5</option>
                    <option [value]="2">2</option>
                    <option [value]="2.5">2.5</option>
                    <option [value]="3">3</option>
                    <option [value]="3.5">3.5</option>
                    <option [value]="4">4</option>
                    <option [value]="4.5">4.5</option>
                    <option [value]="5">5</option>
                    <option [value]="5.5">5.5</option>
                    <option [value]="6">6</option>
                    <option [value]="6.5">6.5</option>
                  </select>
                  <div class="invalid-message">
                    <div>{{ cert.certificationBody.subType1Name }} {{ cert.certificationBody.unitName }} are required</div>
                  </div>
                </div>
                <div *ngIf="cert.certificationBody.subType2Name" class="col-md-3">
                  <label for="country">{{ cert.certificationBody.shortName }} {{ cert.certificationBody.subType2Name }} {{ cert.certificationBody.unitName }}</label>
                  <i class="fa fa-asterisk"></i>
                  <select class="form-control" formControlName="subType2CeuCount">
                    <option [value]="0">0</option>
                    <option [value]=".5">.5</option>
                    <option [value]="1">1</option>
                    <option [value]="1.5">1.5</option>
                    <option [value]="2">2</option>
                    <option [value]="2.5">2.5</option>
                    <option [value]="3">3</option>
                    <option [value]="3.5">3.5</option>
                    <option [value]="4">4</option>
                    <option [value]="4.5">4.5</option>
                    <option [value]="5">5</option>
                    <option [value]="5.5">5.5</option>
                    <option [value]="6">6</option>
                    <option [value]="6.5">6.5</option>
                  </select>
                  <div class="invalid-message">
                    <div>{{ cert.certificationBody.subType2Name }} {{ cert.certificationBody.unitName }} are required</div>
                  </div>
                </div>
                <div *ngIf="cert.certificationBody.subType3Name" class="col-md-3">
                  <label for="country">{{ cert.certificationBody.shortName }} {{ cert.certificationBody.subType3Name }} {{ cert.certificationBody.unitName }}</label>
                  <i class="fa fa-asterisk"></i>
                  <select class="form-control" formControlName="subType3CeuCount">
                    <option [value]="0">0</option>
                    <option [value]=".5">.5</option>
                    <option [value]="1">1</option>
                    <option [value]="1.5">1.5</option>
                    <option [value]="2">2</option>
                    <option [value]="2.5">2.5</option>
                    <option [value]="3">3</option>
                    <option [value]="3.5">3.5</option>
                    <option [value]="4">4</option>
                    <option [value]="4.5">4.5</option>
                    <option [value]="5">5</option>
                    <option [value]="5.5">5.5</option>
                    <option [value]="6">6</option>
                    <option [value]="6.5">6.5</option>
                  </select>
                  <div class="invalid-message">
                    <div>{{ cert.certificationBody.subType3Name }} {{ cert.certificationBody.unitName }} are required</div>

                  </div>
                </div>
                <div *ngIf="$any(this.formGroup.controls.ceus).controls[i]?.errors?.totalCEUExceeded" class="col-md-12 invalid-message-visible">
                  <span *ngIf="cert.certificationBody.subType1Name">{{ cert.certificationBody.subType1Name }}</span> <span *ngIf="cert.certificationBody.subType2Name"> + {{ cert.certificationBody.subType2Name }}</span> <span *ngIf="cert.certificationBody.subType3Name"> + {{ cert.certificationBody.subType3Name }}</span> must not exceed {{cert.certificationBody.baseTypeName}} count
                  </div>
              </div>

            </ng-container>
          </div>

          <h5 class="card-header border-top">Abstract<i class="fa fa-asterisk"></i></h5>
          <div class="card-body">
            <ckeditor [editor]="Editor" formControlName="description" [config]="htmlEditorConfig"
                      style="width: 100%"></ckeditor>
            <div class="invalid-message">
              <div>Description is required</div>
            </div>
          </div>
        </ng-container>
      </div>
    </form>
  </div>
</div>
